export const contentTableConfig = {
  title: '统计列表',
  propList: [
    {prop: 'channelName', label: '渠道', minWidth: '50'},
    {prop: 'resourcesCount', label: '资源数', minWidth: '50', sortable: true},
    {prop: 'repeatRate', label: '重复率', minWidth: '50', sortable: true, slotName: 'repeatRate'},
    {prop: 'deleteRate', label: '24小时删除率', minWidth: '70', sortable: true, slotName: 'deleteRate'},
    {prop: 'openRate', label: '开口率（第二次）', minWidth: '70', sortable: true, slotName: 'openRate'},
    {prop: 'lookRate', label: '看课率（直播）', minWidth: '70', sortable: true, slotName: 'lookRate'}
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
